<template>
  <canvas
    :id="chartData.id"
  />
</template>

<script>
import Chart from 'chart.js/auto'
import { isSmallDevice } from '@/service/layout'
import numberFilter from '@/filters/number.filter'

export default {
  name: 'BaseComparaisonLineChart',
  props: {
    chartData: {
      type: Object,
      default: () => { }
    },
    
    ordonnee: {
      type: String,
      required: true
    },
    precision: {
      type: Number,
      default: 0
    },
    unite: {
      type: String,
      default: ''
    },
    min: {
      type: Number,
      default: undefined
    },
    max: {
      type: Number,
      default: undefined
    },
    id: {
      type: String,
      default: ''
    },
    tooltipLabelPerso: {
      type: String,
      default: null
    },
    tooltipLabelGroupe: {
      type: String,
      default: null
    },
    displayLegend: {
      type: Boolean,
      default: false
    },
    isMaintainAspectRatio: {
      type: Boolean,
      default: true
    },
  },
  data () {
    return {
      chart: null,
      options: {
        responsive: true,
        aspectRatio: 1.5,
        scales: {
          y: {
            title: {
              display: true,
              text: this.ordonnee
            },
            ticks: {
              stepSize: 10,
              fontSize: this.fontSize(),
              precision: 10,
              maxTicksLimit: 5
            }
          },
          x: {
            scaleLabel: {
              display: true
            },
            ticks: {
              fontSize: this.fontSize(),
              maxTicksLimit: isSmallDevice() ? 6 : 13
            }
          }
        },
        animations: { duration: 0 },
        plugins: {
          datalabels: {
            display: false
          },
          tooltip: {
            mode: 'nearest',
            intersect: false,
            callbacks: {
              // eslint-disable-next-line no-unused-vars
              label: (context) => {
                let tooltipLabel = null
                if (this.chartData.datasets[1]!= null && this.chartData.datasets[1].nbGroupe != null) {
                  if (this.tooltipLabelPerso && this.tooltipLabelGroupe) {
                    let nbAdherentsCompares
                    let nbAdherents
                    nbAdherentsCompares = this.chartData.datasets[1].nbGroupe[context.dataIndex]
                    nbAdherents = nbAdherentsCompares + ' adhérent'
                    if (nbAdherentsCompares > 1) {
                      nbAdherents += 's'
                    }
                    tooltipLabel = context.datasetIndex === 0 ? this.tooltipLabelPerso : this.tooltipLabelGroupe + '(' + nbAdherents + ') : '
                  }
                } else {
                  tooltipLabel = context.datasetIndex === 0 ? this.tooltipLabelPerso : this.tooltipLabelGroupe
                }
                tooltipLabel = tooltipLabel ? tooltipLabel + numberFilter.formatDecimal(context.parsed.y, this.precision) + ' ' + this.unite : numberFilter.formatDecimal(context.parsed.y, this.precision) + ' ' + this.unite
                if (this.chartData.datasets[0].isPrixProvisoire && context.dataIndex === 3) {
                  tooltipLabel += ' (provisoire)'
                }
                return tooltipLabel
              }
            },
            displayColors: false,
            // Désactive le tooltip en rajoutant 'tooltipDisabled = true' dans le dataset
            filter: (context) => {
              return context.dataset.data[context.dataIndex] != null
            }
          },
          legend: {
            display: this.displayLegend,
            position: 'bottom'
          },
        }
      }
    }
  },
  watch: {
    chartData: {
      handler () {
        this.chart.data = this.chartData
        this.chart.update()
      }
    }
  },

  mounted () {
    this.options.maintainAspectRatio = this.isMaintainAspectRatio
    const config = {
      type: 'line',
      options: this.options,
      data: this.chartData
    }
    this.chart = new Chart(document.getElementById(this.id), config)
  },
  methods: {
    fontSize () {
      return isSmallDevice() ? 12 : 18
    }
  }
}
</script>